import {
  Dialog,
  DialogDescription,
  DialogHeader,
  DialogPanel,
  DialogPopup,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { StrategySnapshot } from "@/lib/strategy-snapshot";
import { KEYWORD_SCREENING, KEYWORD_SCREENING_COLUMNS } from "@/mocks/operating-strategy";
import { STRATEGY_KEYWORD_COLUMNS } from "@/mocks/strategy-product";

interface KeywordPreviewDialogProps {
  fileName: string;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  productSnapshot?: StrategySnapshot;
}

export function KeywordPreviewDialog({
  fileName,
  onOpenChange,
  open,
  productSnapshot,
}: KeywordPreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPopup className="max-w-[720px]">
        <DialogHeader>
          <DialogTitle>{fileName}</DialogTitle>
          <DialogDescription>以下为商品搜索词节选；完整筛选结果请下载 Excel。</DialogDescription>
        </DialogHeader>
        <DialogPanel>
          <div className="overflow-hidden rounded-[10px] border border-line">
            <Table>
              <TableHeader>
                <TableRow>
                  {(productSnapshot ? STRATEGY_KEYWORD_COLUMNS : KEYWORD_SCREENING_COLUMNS).map(
                    (column) => (
                      <TableHead key={column}>{column}</TableHead>
                    ),
                  )}
                </TableRow>
              </TableHeader>
              <TableBody>
                {productSnapshot
                  ? productSnapshot.keywords.map((row) => (
                      <TableRow key={row.keyword}>
                        <TableCell>{row.keyword}</TableCell>
                        <TableCell>{row.status}</TableCell>
                      </TableRow>
                    ))
                  : KEYWORD_SCREENING.map(([keyword, volume, relevance, recommendation]) => (
                      <TableRow key={keyword}>
                        <TableCell>{keyword}</TableCell>
                        <TableCell className="font-mono tabular-nums">
                          {volume.toLocaleString("en-US")}
                        </TableCell>
                        <TableCell>{relevance}</TableCell>
                        <TableCell>{recommendation}</TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </div>
        </DialogPanel>
      </DialogPopup>
    </Dialog>
  );
}
